import { handleSubpublishers, mapAgeRestrictedSetting } from '../../../helpers'

export const DTOCreateDigitalSignageCampaign = (
  data: DTOCreateDigitalSignageCampaignPayload & {
    lengthCentsCurrency: number
    costType: CampaignPermissionsCostType
  }
) => {
  /**
   * Handle places
   */

  const { lengthCentsCurrency, costType } = data

  const allPlaces = data.places.placesCheck === 'all'

  const getPlacesIds = () =>
    data?.places?.place_ids
      ? data?.places?.place_ids?.split(',').map(item => ({ id: Number(item) }))
      : []

  // "all screens" mode: the backend resolves the publisher's full place list
  // at creation/cost-check time (use_all_places), so the FE no longer needs
  // to enumerate ids here -- which used to be capped at 100 by the places
  // search endpoint and silently dropped screens for bigger publishers.
  const places = allPlaces ? [] : getPlacesIds()

  const totalBudgetRaw = data?.total_budget?.numAsString
  const totalBudgetValue = lengthCentsCurrency
    ? Number(totalBudgetRaw) / 100
    : Number(totalBudgetRaw)

  let total_budget = null
  if (totalBudgetRaw) {
    total_budget = totalBudgetValue
  } else if (!isNaN(Number(data?.total_budget))) {
    total_budget = data?.total_budget
  }
  const dailyBudgetRaw = data?.budget?.daily?.numAsString
  const dailyBudget = lengthCentsCurrency
    ? Number(dailyBudgetRaw) / 100
    : Number(dailyBudgetRaw)

  const assets = data?.video?.assets?.map(item => ({
    ad_size: item.ad_size,
    media_url: item.media_url,
    width: item.width,
    height: item.height,
    duration: item.duration,
    file_size: item.file_size ?? null
  }))

  let body: DTOCreateDigitalSignageCampaignResponse = {
    type: 'in_store',
    ad_type: 'digital_signage',

    start_at: data.start_date,
    end_at: data.end_date,

    name: data.name,
    description: data?.description,

    video: {
      assets
    },
    settings: {
      cpc: null,
      places,
      use_all_places: allPlaces,
      cost_type: costType || null,
      ...mapAgeRestrictedSetting(data?.settings)
    }
  }

  if (total_budget) {
    body.total_budget = total_budget
  }

  if (dailyBudget) {
    body.settings.daily_budget = dailyBudget
  }

  if (data.publisher_id) {
    body.publisher_id = data.publisher_id
  }

  body = handleSubpublishers<DTOCreateDigitalSignageCampaignResponse>({
    body,
    data
  })

  return body
}
